import React, { useState } from "react";
import { initializeApp } from "firebase/app";
import { getAI, getGenerativeModel, GoogleAIBackend } from "firebase/ai";
import { firebaseConfig } from "../../config/firebase"; // Ensure firebaseConfig is exported

// Firebase Initialization
const firebaseApp = initializeApp(firebaseConfig);
const ai = getAI(firebaseApp, { backend: new GoogleAIBackend() });
const model = getGenerativeModel(ai, { model: "gemini-1.5-flash" });

const GeminiAIComponent = () => {
  const [prompt, setPrompt] = useState("");
  const [response, setResponse] = useState("");
  const [loading, setLoading] = useState(false);

  const generateContent = async () => {
    if (!prompt.trim()) return;
    setLoading(true);
    try {
      const result = await model.generateContent(prompt);
      const text = await result.response.text();
      setResponse(text);
    } catch (error) {
      console.error("AI generation failed:", error);
      setResponse("❌ Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-10">
      <h2 className="text-2xl font-bold text-center text-indigo-700 mb-6">
        💡 Ask Gemini AI
      </h2>

      <textarea
        rows="6"
        className="w-full p-4 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-indigo-500"
        placeholder="Enter your prompt here..."
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
      />

      <button
        onClick={generateContent}
        disabled={loading}
        className={`w-full mt-4 py-3 px-6 text-white text-lg font-semibold rounded-lg transition-all ${
          loading
            ? "bg-gray-400 cursor-not-allowed"
            : "bg-indigo-600 hover:bg-indigo-700"
        }`}
      >
        {loading ? "Generating..." : "✨ Generate Response"}
      </button>

      {response && (
        <div className="mt-6 bg-gray-50 border border-gray-200 rounded-lg p-4">
          <h3 className="text-lg font-semibold mb-2 text-gray-800">
            📜 Response:
          </h3>
          <p className="text-gray-700 whitespace-pre-wrap leading-relaxed">
            {response}
          </p>
        </div>
      )}
    </div>
  );
};

export default GeminiAIComponent;
